function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint no-console: "off" */
import { ERROR, WARN, INFO, DEBUG, DEBUG2 } from "./LoggerLevel.js";
var silent = () => undefined;
class Logger {
  constructor(name, level) {
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "prefix", void 0);
    _defineProperty(this, "level", void 0);
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "warn", void 0);
    _defineProperty(this, "log", void 0);
    _defineProperty(this, "info", void 0);
    _defineProperty(this, "debug", void 0);
    _defineProperty(this, "debug2", void 0);
    this.name = name;
    this.prefix = name != null ? "[".concat(name, "]") : "";
    this.error = silent;
    this.warn = silent;
    this.log = silent;
    this.info = silent;
    this.debug = silent;
    this.debug2 = silent;
    this.level = level;
    this.setLogLevel(level);
  }
  setLogLevel(level) {
    if (!Number.isFinite(level)) {
      console.warn("Expected a number for log level. Received: ".concat(level, ". Ignoring"));
      return;
    }
    this.level = level;
    this.error = level >= ERROR ? console.error.bind(console, this.prefix) : silent;
    this.warn = level >= WARN ? console.warn.bind(console, this.prefix) : silent;
    this.log = level >= INFO ? console.log.bind(console, this.prefix) : silent;
    this.info = this.log;
    this.debug = level >= DEBUG ? console.debug.bind(console, this.prefix) : silent;
    this.debug2 = level >= DEBUG2 ? console.debug.bind(console, this.prefix) : silent;
  }
}
export default Logger;
//# sourceMappingURL=Logger.js.map